module.exports = __webpack_public_path__ + "img/avenger96.b3b47beb.jpg";